import * as React from "react";

function SvgGroupSearch(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={27.465} height={25.231} {...props}>
      <g data-name="Group 12099">
        <g data-name="Group 12092" fill="#039be5">
          <g data-name="Icon feather-users">
            <path
              data-name="Path 43189"
              d="M21.168 25.228a1 1 0 01-1-1v-2a3.006 3.006 0 00-3-3h-8a3 3 0 00-3 3v2a1 1 0 01-2 0v-2a5 5 0 015-5h8a5.008 5.008 0 015 5v2a1 1 0 01-1 1z"
            />
            <path data-name="Path 43190" d="M12.235 5.221a5 5 0 11-5 5 5.008 5.008 0 015-5zm0 8a3 3 0 10-3-3 3.006 3.006 0 003 3z" />
            <path
              data-name="Path 43191"
              d="M26.456 25.232a1 1 0 01-1-1v-2-.492c.015-1.113-.015-1.532-.415-1.828a7.791 7.791 0 00-2.764-.426c-1.232-.074-2.345-.068-2.356-.068a1 1 0 11-.013-2c.05 0 1.234-.007 2.56.076 2.575.161 3.357.513 3.751.8 1.271.932 1.253 2.281 1.237 3.472v2.464a1 1 0 01-1 1.002z"
            />
            <path
              data-name="Path 43192"
              d="M20.17 15.106a1 1 0 01-.247-1.969 3 3 0 000-5.817 1 1 0 01.5-1.937 5 5 0 010 9.692 1 1 0 01-.253.031z"
            />
          </g>
          <g data-name="Icon feather-search">
            <path
              data-name="Path 43209"
              d="M10.314.001a8.451 8.451 0 11-8.451 8.451A8.461 8.461 0 0110.314.001zm0 14.9a6.451 6.451 0 10-6.451-6.449 6.458 6.458 0 006.451 6.449z"
            />
            <path
              data-name="Path 43210"
              d="M1 18.767a1 1 0 01-.707-1.707l4.052-4.052a1 1 0 011.414 1.414l-4.052 4.052a1 1 0 01-.707.293z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgGroupSearch;
